import { API_BASE, ApiError } from "../../api";
import { sessionExpiredEvent } from "../../route-auth";

export async function downloadConversation(id: string) {
  const response = await fetch(
    `${API_BASE}/conversations/${encodeURIComponent(id)}/export`,
    { credentials: "include" },
  );
  if (!response.ok) {
    if (response.status === 401)
      window.dispatchEvent(new Event(sessionExpiredEvent));
    const body = await response.json().catch(() => ({}));
    throw new ApiError(
      typeof body.error === "string"
        ? body.error
        : "Could not export conversation",
      response.status,
    );
  }
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `lumen-conversation-${id}.zip`;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // Allow the browser to start consuming the download before releasing it.
  window.setTimeout(() => URL.revokeObjectURL(url), 1_000);
}
